import { React } from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider ,
  redirect  
} from "react-router-dom";
import './index.css';
import App from './App';
import Detail from './Detail';
import reportWebVitals from './reportWebVitals';
import { jwtDecode } from "jwt-decode";
const pjson = require('../package.json')
const apiURL = (process.env.NODE_ENV === 'development') ? 'http://localhost/mediatheken/epub/data' : `https://lib.arteveldehogeschool.be/mediatheken/epub/data`
const loginUrl = (process.env.NODE_ENV === 'development') ? `http://localhost/mediatheken/loginDemo.php` : `https://lib.arteveldehogeschool.be/mediatheken/loginLink.php`


const base = pjson.homepage

const refreshToken = () => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + localStorage.getItem('token'));
  
  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow"
  };

  fetch(`${loginUrl}?call=refreshToken/`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if(!!result.token) {
          localStorage.setItem('token' , result.token)
        } else {
          localStorage.removeItem('token')
        }
      })
      .catch((error) => console.error(error));
}
    
const router = createBrowserRouter([
  {
    path: base ,
    loader: async() => {
      let user = null
      if(!!localStorage.getItem('token')) {
        const userToken = localStorage.getItem('token')
        user = jwtDecode(userToken)
        if(!!user.exp && (new Date() > new Date(user.exp * 1000))) {
          user = null
          localStorage.removeItem('token')
        }
        /*
        if(!!!user.exp || ((new Date(user.exp * 1000) - new Date()) < (1000 * 60 * 10) )) {
          refreshToken()
        }
        */
      }
      const data = await fetch(`${apiURL}/epublicaties.json`)
      const response = await data.json()
      response.autoload = null
      return {
        epub : response ,
        user : user
      }
    } ,
    element: <App /> ,
  }
  , {
    path : base + 'detail/:id' ,
    loader : async ({ params }) => {
      let user = null
      if(!!localStorage.getItem('token')) {
        const userToken = localStorage.getItem('token')
        user = jwtDecode(userToken)
        if(!!user.exp && (new Date() > new Date(user.exp * 1000))) {
          user = null
          localStorage.removeItem('token')
        }
        /*
        if(!!!user.exp || ((new Date(user.exp * 1000) - new Date()) < (1000 * 60 * 10)) ) {
          refreshToken()
        }
          */
      }
      const data = await fetch(`${apiURL}/getDetail/${params.id}`)
      if(!data.ok) {
        return null;
      }
      const response = await data.json()
      return {
        detail : response ,
        user : user
      }
    } ,
    element : <Detail />
  } , {
    path : base + ':filter/:value' ,
    loader: async({ params }) => {
      let user = null
      if(!!localStorage.getItem('token')) {
        const userToken = localStorage.getItem('token')
        user = jwtDecode(userToken)
        if(!!user.exp && (new Date() > new Date(user.exp * 1000))) {
          user = null
          localStorage.removeItem('token')
        }
        /*
        if(!!!user.exp || (new Date(user.exp * 1000) - new Date()) < (1000 * 60 * 10) ) {
          refreshToken()
        }
          */
      }
      const data = await fetch(`${apiURL}/epublicaties.json`)
      if (!data.ok) {
        return null;
      }
      const response = await data.json()
      response.autoload = params
      return {
        epub : response ,
        user : user
      }
    } ,
    element: <App />
  } 
  , {
    path : base + 'share/:filters' ,
    loader: async({ params }) => {
      let user = null
      if(!!localStorage.getItem('token')) {
        const userToken = localStorage.getItem('token')
        user = jwtDecode(userToken)
        if(!!user.exp && (new Date() > new Date(user.exp * 1000))) {
          user = null
          localStorage.removeItem('token')
        }
        /*
        if(!!!user.exp || (new Date(user.exp * 1000) - new Date()) < (1000 * 60 * 10) ) {
          refreshToken()
        }
          */
      }
      const data = await fetch(`${apiURL}/epublicaties.json`)
      if (!data.ok) {
        return null;
      }
      const response = await data.json()
      let twSplit = params.filters.split('|')
      response.filterTest = {}
      response.filterTest.trefwoorden = []
      if(twSplit[1] !== undefined) {
        response.filterTest.trefwoorden =  twSplit[1].split('+')
      }
      let filtertest = twSplit[0].split('+')
      response.filterTest.query = filtertest[0]
      response.filterTest.filters = []
      response.filterTest.filters = []
      for(let i = 1 ; i < filtertest.length ; i++) {
        response.filterTest.filters.push(filtertest[i])
      }
      return {
        epub : response ,
        user : user
      }
    } ,
    element: <App />
  } ,
  {
    path: base + 'setToken/:token',
    loader: ({params}) => {
      localStorage.setItem('token' , atob(params.token))
      let goTo = base
      if(!!localStorage.getItem('redirect')) {
        goTo = base + localStorage.getItem('redirect')
      } 
      return redirect(goTo)
    } ,
    element: () => {
      return redirect(base)
    } ,
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RouterProvider router={router} />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
